<template>
  <div id="wrap">
    <HeaderSection :show-overlay="showOverlay" @mode-change="handleModeChange"/>
    <div @toggle="togglePanel" class="panel on">
      <MenuSnb/>
      <router-view :key="$route.fullPath" @mode-change="handleModeChange"/>
    </div>
    <GlobalOverlay/>
  </div>
</template>
<script setup>
import {onMounted, ref} from 'vue';
import HeaderSection from '@/components/layout/Header.vue';
import MenuSnb from '@/components/snb/MenuSnb.vue';
import GlobalOverlay from '@/components/ui/GlobalOverlay.vue';

const showOverlay = ref(false);
const mode = ref('none');

const handleModeChange = (newMode) => {
  mode.value = newMode;
  showOverlay.value = (newMode !== 'none');
};

const redirectIfWww = () => {
  const host = window.location.hostname;
  const url = window.location.href;

  if (host.startsWith('www.')) {
    const newUrl = url.replace('://www.', '://');
    window.location.replace(newUrl);
  }
};

onMounted(() => {
  document.body.classList.remove('on');
  document.querySelector('.panel').classList.add('on');
  redirectIfWww();
});
const togglePanel = () => {
  document.querySelector('.panel').classList.toggle('on');
};
</script>

<style>
.custom-select.v-select {
  width: 100%;
  font-size: 15px;
  font-weight: 500;
  height: 45px;
}

.custom-select.v-select input::placeholder {
   color: #B7B7B7;
}

.custom-select.vs--searchable .vs__dropdown-toggle {
  height: 100%;
}

</style>